import {FC, useEffect, useState} from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import Select from 'react-select'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {CampModel, MasterModel, ModuleModel, SiteModel} from '../../../modules/models'
import {getModulesService} from '../../../modules/services'
import {getCampsService} from '../../../modules/services/getCamps.service'
import {getMasterModuleService} from '../../../modules/services/getModuleTypes.service'
import {getSitesService} from '../../../modules/services/getSites.service'

const FormNewRoom: FC = () => {
  const [sites, setSites] = useState<SiteModel[] | any>([])
  const [camps, setCamps] = useState<CampModel[] | any>([])
  const [moduleType, setModuleType] = useState<MasterModel[] | any>([])
  const [level, setLevel] = useState<MasterModel[] | any>([])
  const [preasignationType, setPreasignationType] = useState<MasterModel[] | any>([])
  const [genre, setGenre] = useState<MasterModel[] | any>([])
  const [bathroomType, setBathroomType] = useState<MasterModel[] | any>([])
  const [roomType, setRoomType] = useState<MasterModel[] | any>([])
  const [statusRoom, setStatusRoom] = useState<MasterModel[] | any>([])
  const [subStatusRoom, setSubStatusRoom] = useState<MasterModel[] | any>([])
  const [modules, setModules] = useState<ModuleModel[] | any>([])
  const [statusPadre, setStatusPadre] = useState('')

  const {
    register,
    formState: {errors},
    control,
    setValue,
    watch,
  } = useFormContext()

  const getSites = async () => {
    let obj: SiteModel = {
      id: '',
      nombre: '',
      campoadicionaltxt1: '',
      campoadicionaltxt2: '',
      campoadicionaltxt3: '',
      campoadicionaltxt4: '',
      campoadicionaltxt5: '',
      campoadicionalnum1: 0,
      campoadicionalnum2: 0,
      campoadicionalnum3: 0,
      campoadicionalFec1: '',
      campoadicionalFec2: '',
      fechaRegistro: '',
      usuarioRegistro: '',
      iPPlacaRegistro: '',
      fechaModificacion: '',
      usuarioModificacion: '',
      iPPlacaModificacion: '',
      fechaEliminacion: '',
      usuarioEliminacion: '',
      iPPlacaEliminacion: '',
    }
    const response = await getSitesService(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((site) => ({value: site.id, label: site.nombre}))
    setSites(mappedSites)
  }
  const getCamps = async (siteId: string) => {
    let obj: CampModel = {
      id: '',
      nombre: '',
      siteId: siteId,
      clienteId: '',
      companiaId: '',
      site: '',
      nombreCliente: '',
      nombreCompania: '',
    }
    const response = await getCampsService(obj, 1)
    const data = response.data.data
    const mappedCamps = data.map((camp) => ({value: camp.id, label: camp.nombre}))
    setCamps(mappedCamps)
  }
  const getModuleTypes = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'TipoModulo',
    })
    const data = response.data.data
    const mappedModuleTypes = data.map((moduleType) => ({
      value: moduleType.id,
      label: moduleType.nombreCorto,
    }))
    setModuleType(mappedModuleTypes)
  }
  const getLevels = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'Nivel',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setLevel(mappedMaster)
  }

  const getModules = async (siteId: string, campamentoId: string) => {
    const {data: response} = await getModulesService({
      SiteId: siteId,
      CampamentoId: campamentoId,
      pageNumber: 1,
      size: 1000,
    })
    const mappedModules = response.data?.map((item) => ({value: item.Id, label: item.Codigo}))
    setModules(mappedModules)
  }

  const getPreasignationTypes = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'TipoPreasignacion',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setPreasignationType(mappedMaster)
  }
  const getGenres = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'Sexo',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setGenre(mappedMaster)
  }
  const getBathroomsType = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'TipoBanio',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setBathroomType(mappedMaster)
  }

  const getRoomsType = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'TipoHabitacion',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setRoomType(mappedMaster)
  }

  const getStatusRoom = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'EstadoHabitacion',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
      codigo: master.codigo,
    }))
    setStatusRoom(mappedMaster)
  }

  const getSubStatusRoom = async (statusPadre: string) => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'SubEstadoHabitacion',
    })
    const data = response.data.data || []
    const filteredData = data?.filter((item) => item.codigoPadre === statusPadre)
    const mappedMaster = filteredData?.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setSubStatusRoom(mappedMaster)
  }

  useEffect(() => {
    if (statusPadre) {
      getSubStatusRoom(statusPadre)
    }
  }, [statusPadre])

  useEffect(() => {
    getSites()
    getModuleTypes()
    getLevels()
    getPreasignationTypes()
    getGenres()
    getBathroomsType()
    getRoomsType()
    getStatusRoom()
    // getSubStatusRoom()
    setValue('EstadoHabitacionId', 'lx6Fw1G17S8=')
    setValue('SubEstadoHabitacionId', 'e7C62LSXBTA=')
    setStatusPadre('1')
  }, [])

  useEffect(() => {
    const siteId = watch('SiteId')
    if (siteId) {
      setValue('CampamentoId', '')
      getCamps(siteId)
    }
  }, [watch('SiteId')])

  useEffect(() => {
    const siteId = watch('SiteId')

    const campamentoId = watch('CampamentoId')
    if (campamentoId && siteId) {
      setValue('Codigo', '')
      getModules(siteId, campamentoId)
    } else {
      setModules([])
    }
  }, [watch('CampamentoId')])

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <div className='d-flex row'>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Site</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='SiteId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={sites}
                        placeholder='Selecciona un site'
                        value={sites?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.SiteId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Campamento</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='CampamentoId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={camps}
                        placeholder='Selecciona un campamento'
                        value={camps?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.CampamentoId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Tipo de Módulo</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='TipoModuloId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={moduleType}
                        placeholder='Selecciona un tipo de modulo'
                        value={moduleType?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.TipoModuloId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Código de Módulo</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='ModuloId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={modules}
                        placeholder='Selecciona un tipo de modulo'
                        value={modules?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.TipoModuloId?.message?.toString()}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Tipo de Habitación</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='TipoHabitacionId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={roomType}
                        placeholder='Selecciona un tipo de habitacion'
                        value={roomType?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.TipoHabitacionId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Código de Habitación</label>
                <div className='input-group input-group-sm'>
                  <input type='text' className='form-control' {...register('Codigo')} />
                </div>
                <p
                  style={{
                    marginBottom: '0',
                    fontSize: '10px',
                    fontWeight: '600',
                    color: 'red',
                    marginLeft: '5px',
                  }}
                >
                  {errors.Codigo?.message?.toString()}
                </p>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Estado</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='EstadoHabitacionId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={statusRoom}
                        placeholder='Selecciona un estado'
                        value={statusRoom?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => {
                          field.onChange(val ? val.value : '')
                          setStatusPadre(val?.codigo)
                          setValue('SubEstadoHabitacionId', '')
                        }}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.EstadoHabitacionId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Sub Estado</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='SubEstadoHabitacionId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={subStatusRoom}
                        placeholder='Selecciona un estado'
                        value={subStatusRoom?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.SubEstadoHabitacionId?.message?.toString()}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Preasignación</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='TipoPreAsignacionId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={preasignationType}
                        placeholder='Selecciona un tipo de preasignacion'
                        value={preasignationType?.find(
                          (c: {value: string}) => c.value === field.value,
                        )}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.TipoPreAsignacionId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Sexo</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='SexoId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={genre}
                        placeholder='Selecciona un Sexo'
                        value={genre?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.SexoId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Tipo de Baño</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='TipoBanioId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={bathroomType}
                        placeholder='Selecciona un Tipo de Baño'
                        value={bathroomType?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.TipoBanioId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Nivel</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='NivelId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={level}
                        placeholder='Selecciona un Nivel'
                        value={level?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.NivelId?.message?.toString()}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Nro de Camas</label>
                <div className='input-group input-group-sm'>
                  <input type='text' className='form-control' {...register('NroCamas')} />
                </div>
                <p
                  style={{
                    marginBottom: '0',
                    fontSize: '10px',
                    fontWeight: '600',
                    color: 'red',
                    marginLeft: '5px',
                  }}
                >
                  {errors.NroCamas?.message?.toString()}
                </p>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Prioridad de Asignación</label>
                <div className='input-group input-group-sm'>
                  <input
                    type='text'
                    className='form-control'
                    {...register('PrioridadAsignacion')}
                  />
                </div>
                <p
                  style={{
                    marginBottom: '0',
                    fontSize: '10px',
                    fontWeight: '600',
                    color: 'red',
                    marginLeft: '5px',
                  }}
                >
                  {errors.PrioridadAsignacion?.message?.toString()}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className='d-flex justify-content-center mb-3'>
            <button type='submit' className='btn btn-primary'>
              Guardar
            </button>
          </div> */}
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </KTCard>
    </>
  )
}

export {FormNewRoom}
